import { render, staticRenderFns } from "./AutoExtensionPanel.vue?vue&type=template&id=3e6fa48b&scoped=true&"
import script from "./AutoExtensionPanel.vue?vue&type=script&lang=js&"
export * from "./AutoExtensionPanel.vue?vue&type=script&lang=js&"
import style0 from "./AutoExtensionPanel.vue?vue&type=style&index=0&id=3e6fa48b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6fa48b",
  null
  
)

export default component.exports